import { FragmentDefiner } from "../../../../GlobalHooks/useReadFragment";
import { useSendTextLead } from "../../../../GlobalHooks/useSendLead";
import { PropComponentMode } from "../../../../Components/Property/PropertyInterfaces";

export const FRAGMENT_PROPERTY_MODAL_VIDEO = new FragmentDefiner(
	"Property",
	`
    id
    youtube
    project {
        id
    }
`
);

type usePropertyModalVideoProps = {
	id: string;
	mode: PropComponentMode;
	isProject: boolean;
};

export function usePropertyModalVideo({ id, mode, isProject }: usePropertyModalVideoProps) {
	const { sendLead, loading: loadingSendLead } = useSendTextLead({
		property_id: id,
		entity_type: (isProject && mode == "auto") || mode == "project" ? "PROJECT" : "PROPERTY",
		financing_information: false,
		isAutoGenerated: false,
		source: 14,
		message: "Me gustaría ver un video de la propiedad",
	});

	return { loadingSendLead, sendLead };
}
